import axios from "axios";
import { getApiConfig } from "../../apiConfig";

export async function PatchNotificationViewFeedback(notificationId, modifiedBy) {
  try {
    const apiConfig = await getApiConfig();

    const req = `${apiConfig.BASE_URL}notification/${notificationId}`;

    const notificationPatch = {
      view : true,
      modifiedBy : modifiedBy
    }

    const response = await axios.patch(req, notificationPatch, apiConfig.HEADERS_CONFIG, { });



    // Devolver la respuesta original si es necesario
    return response.data;

  } catch (error) {
    // Manejar el error
    throw error;
  }
}